import { Stack } from "@mui/material";
import MyHeartRateScreen from ".";
import type { HeartRateDataPoint } from "./HeartRateChart";
import { WellnessScoreStatus } from "../../Common/types";

const sampleChartData: HeartRateDataPoint[] = [
  { date: "20/01", heartRate: 85, fullDate: "20.01.2025" },
  { date: "02/04", heartRate: 70, fullDate: "02.04.2025" },
  { date: "04/04", heartRate: 75, fullDate: "04.04.2025" },
  { date: "12/05", heartRate: 80, fullDate: "12.05.2025" },
  {
    date: "20/08",
    heartRate: 68,
    fullDate: "20.08.2025",
    isSelected: true,
  },
];

export default function MyHeartRateScreenExamples() {
  return (
    <Stack gap={4} width="100%">
      <MyHeartRateScreen
        chartData={sampleChartData}
        status={WellnessScoreStatus.Healthy}
        lastUpdated="2025-02-23T00:00:00Z"
      />
    </Stack>
  );
}
